module.exports = __webpack_public_path__ + "static/media/4.85237b0f.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/gomel/4.JPG
// module id = 222
// module chunks = 0